<template>
	<div class="message-bubble catalogue">
		<div v-for="(category, index) in categories" :key="index">
			<div class="catalogue-title">
				{{ category.text }}
			</div>
			<v-list dense light>
				<v-list-item-group color="primary">
					<v-list-item
						v-for="(action, key) in category.additionalParameters"
						:key="key"
					>
						<v-list-item-content
							@click="show(action.id)"
							v-if="action.available === 1"
						>
							<v-btn class="button-rounding">
								{{ action.name }}
							</v-btn>
						</v-list-item-content>
					</v-list-item>
				</v-list-item-group>
			</v-list>
		</div>

		<BackBtn :return_to="'categories'" />
	</div>
</template>

<script>
import BackBtn from "./BackBtn";
export default {
	components: {
		BackBtn,
	},
	data() {
		return {
			current: 0,
		};
	},
	computed: {
		categories: {
			get() {
				let result = Object.values(
					this.$store.getters["chatStore/get_categories"][0]
						.additionalParameters
				);
				result.sort((a, b) => a - b);
				return [{
					text: this.$store.getters["chatStore/get_categories"][0].text,
					additionalParameters: result
				}];
			},
		},
	},
	methods: {
		show(value) {
			let fd = new FormData();
			fd.append("message", `category:${value}`);
			fd.append("driver", "web");
			const data = {
				id: this.$route.params.id,
				data: fd,
			};
			this.$store.dispatch("chatStore/show_products", data);
		},
	},
};
</script>

<style lang="scss">
.catalogue {
	text-align: left;
	.v-list-item {
		padding: 0;
	}
}
.catalogue .v-list {
	border-radius: 15px !important;
	background: var(--chat-bubble-color) !important;
	button {
		width: 100%;
		color: var(--app-button-text) !important;
		background-color: var(--app-button) !important;
	}
}
</style>
